import React from 'react';
import ReactPaginate from 'react-paginate';

const ListingPagination = ({ page = 1, totalPages = 1, onPageChange, hidePagination = false }) => {
  const handleClickPage = (data) => {
    const selectedPage = data.selected + 1;
    onPageChange(selectedPage);
  };
  if (hidePagination || totalPages <= 1) return null;
  return (
    <ReactPaginate
      pageCount={ totalPages }
      onPageChange={ handleClickPage }
      marginPagesDisplayed={ 2 }
      pageRangeDisplayed={ 2 }
      forcePage={ page - 1 }
      previousLabel="Previous"
      nextLabel="Next"
      breakLabel={ <a href="#">...</a> }
      containerClassName="pagination"
      subContainerClassName="pagination"
      activeClassName="active" />
  );
};

export default ListingPagination;



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ListingPagination.jsx